import { useCapabilityValue } from '../../store/devices/useCapabilityValue';

import { Battery } from '../common/Battery';

export function IndicatorBattery({ device, capabilityId }) {
  const [value, , capabilityObj] = useCapabilityValue({
    deviceId: device.id,
    capabilityId,
  });

  if (capabilityObj?.type === 'boolean') {
    switch (value) {
      case true:
        return <Battery percentage={10} />;
      case false:
        return <Battery percentage={100} />;
      default:
        return <Battery percentage={null} />;
    }
  }

  return <Battery percentage={value} />;
}
